export class SearchHandler {
    constructor() {
        this.initialGamesLoaded = false; // Track if initial games are already loaded
        this.init();
    }

    init() {
        [...document.querySelectorAll('.search-block')].forEach(searchBlock => {
            const searchModal = searchBlock.querySelector('.search-modal');
            const searchOpenBtnAll = document.querySelectorAll('.search-button');
            const searchCloseBtn = searchModal?.querySelector('.close-modal-wrapper');
            const searchInput = searchBlock.querySelector('.search-input');
            const resultContainer = searchBlock.querySelector('.games-block-recommended__list');

            searchOpenBtnAll.forEach(searchOpenBtn => {
                searchOpenBtn?.addEventListener('click', () => {
                    this.toggleModal(searchModal, true);
                    if (!this.initialGamesLoaded) {
                        this.loadInitialGames(resultContainer);
                        this.initialGamesLoaded = true; // Prevent multiple initial loads
                    }
                });
            });

            // Close modal
            searchCloseBtn?.addEventListener('click', () => {
                this.toggleModal(searchModal, false);
            });

            // Handle search input
            searchInput?.addEventListener('input', debounce(event => {
                const searchText = event.target.value.trim();
                if (searchText.length > 1) {
                    this.fetchGames(searchText, resultContainer);
                } else {
                    this.initialGamesLoaded = false;
                    this.loadInitialGames(resultContainer); // Reload initial games when input is cleared
                    this.initialGamesLoaded = true;
                }
            }, 300)); // Debounce to limit excessive API calls

            // Add click listener to result container for delegation
            resultContainer.addEventListener('click', (event) => {
                const target = event.target.closest('.games-block-recommended__link');
                if (target) {
                    event.preventDefault();
                    this.handleGameLinkClick(target);
                }
            });
        });
    }

    toggleModal(modal, show) {
        if (modal) {
            const overlay = modal.closest('.search-block')?.querySelector('.search-block__overlay');
            modal.style.display = show ? 'block' : 'none';
            if (overlay) {
                overlay.style.display = show ? 'block' : 'none';
            }
            document.body.classList.toggle('modal-open', show);
        }
    }

    async loadInitialGames(container) {
        if (!this.initialGamesLoaded) { // Ensure this is only called once per session
            await this.fetchGames('', container); // Load initial games with empty filter
        }
    }

    async fetchGames(query, container) {
            
        let __self = this;

        const formData = {
            action: 'search_games',
            nonce: ajaxobject.nonce,
            query: query.trim()
        };

        jQuery.post(ajaxobject.ajaxurl, formData, function (response) {

            if (response.success && response.data && response.data.games) {

                __self.updateUI(response.data.games, container);

            }

        });

    }

    updateUI(games, container) {
        const fallbackThumbnail = myScriptData.default_image;
        if (container) {
            if (games.length === 0) {
                container.innerHTML = 'No matching games found.';
            } else {
                let languagePrefix = this.getLanguagePrefix();
                languagePrefix = languagePrefix == 'en' ? '' : '/' + languagePrefix;
                container.innerHTML = games.map(game => `
                    <li class="games-block-recommended__item">
                        <a href="${languagePrefix}/games/${game.slug}" class="games-block-recommended__link">
                            <img src="${game.url || fallbackThumbnail}" alt="${game.name}" class="games-block-recommended__image">
                            <div class="games-block-recommended__content">
                                <span class="games-block-recommended__name">${game.name}</span>
                                <span class="games-block-recommended__provider">${game.studio.replace(/_/g, ' ')}</span>
                            </div>
                        </a>
                    </li>
                `).join('');
            }
        }
    }

    getLanguagePrefix() {
        const urlPath = window.location.pathname.split('/');
        const availableLanguages = ['es', 'de', 'it', 'pt', 'fr'];
        const currentLanguage = urlPath[1];
        return availableLanguages.includes(currentLanguage) ? currentLanguage : 'en';
    }

    handleGameLinkClick(target) {
        window.location.href = target.href;

    }
}

// Debounce function to limit how often a function can fire
function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
}

new SearchHandler();
